import { render, staticRenderFns } from "./tabAsuransiProfil.vue?vue&type=template&id=1c7d4fc0"
import script from "./tabAsuransiProfil.vue?vue&type=script&lang=js"
export * from "./tabAsuransiProfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports